import { languageSelector } from '../languageSelector';
export var getPrimaryNavLinks = function getPrimaryNavLinks(text) {
  return [{
    parent: {
      text: text[0],
      href: 'study'
    },
    children: [{
      parent: {
        text: text[1]
      },
      children: [{
        text: text[2],
        href: 'homework-help'
      }, {
        text: text[3],
        href: 'understand-a-topic'
      }, {
        text: text[4],
        href: 'writing'
      }]
    }, {
      parent: {
        text: text[5]
      },
      children: [{
        text: text[6],
        href: 'study/qa'
      }, {
        text: text[7],
        href: 'study/tbs'
      }, {
        text: text[8],
        href: 'math-solver'
      }, {
        text: text[9],
        href: 'writing/features/citation-generator'
      }, {
        text: text[10],
        href: 'writing/features/plagiarism-checker'
      }, {
        text: text[11],
        href: 'writing/features/grammar-check'
      }, {
        text: text[12],
        href: 'writing/features/proofreading'
      }]
    }]
  }, {
    parent: {
      text: text[13],
      href: 'career'
    },
    children: [{
      text: text[14],
      href: 'https://www.thinkful.com',
      useAbsolute: true
    }, {
      text: text[15],
      href: 'advice/career-center/'
    }]
  }, {
    parent: {
      text: text[16],
      href: 'learninglab?utm_source=chegg&utm_medium=navbar&utm_campaign=link'
    }
  }];
};
export var getSecondaryNavLinks = function getSecondaryNavLinks(text) {
  return [{
    parent: {
      text: text[0],
      href: 'honorshield',
      configuration: {
        type: 'FOR_EDUCATOR'
      }
    }
  }, {
    parent: {
      text: text[1],
      href: 'contactus',
      configuration: {
        type: 'HELP'
      }
    }
  }, {
    parent: {
      text: 'LanguageSelector',
      configuration: {
        type: 'LANGUAGE_SELECTOR',
        position: '1'
      }
    },
    children: languageSelector.children
  }, {
    parent: {
      text: text[2],
      href: 'auth',
      configuration: {
        type: 'SIGN_IN'
      }
    }
  }];
};
export var getBookLinks = function getBookLinks(text) {
  return {
    parent: {
      text: text[0],
      href: 'books'
    },
    children: [{
      text: text[1],
      href: 'books'
    }, {
      text: text[2],
      href: 'etextbooks'
    }, {
      text: text[3],
      href: 'returnbooks'
    }, {
      text: text[4],
      href: 'sell-textbooks'
    }]
  };
};